import React, { useState, useEffect, useRef } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { DataTable } from 'primereact/datatable';
import classNames from 'classnames';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import SeleccionDepartamento from '../components/SeleccionDepartamento';
import SeleccionMunicipios from '../components/SeleccionMunicipios';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'; // ← AGREGAR ESTA LÍNEA
import SeleccionTipoDocumentoOtros from '../components/SeleccionTipoDocumentoOtros';
import SeleccionEstadoTercero from '../components/SeleccionEstadoTercero';

const Terceros = () => {
    let emptyProduct = {
        TID_TERCERO:'',
        NID_TERCERO:'',
        NOMBRE:'',
        DEP_CODIGO:'',
        MUN_CODIGO:'',
        DIRECCION:'',
        TELEFONOS:'',
        CORREO:'',
        URL:'.',
    };
    const [products, setProducts] = useState([]);
    const [productDialog, setProductDialog] = useState(false);
    const [product, setProduct] = useState(emptyProduct);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [value1, setValue1] = useState(true)
    const [adicionarRegistro, setAdicionarRegistro] = useState(0)
    const toast = useRef(null);
    const dt = useRef(null);
    const [reloadUsuarios, setReloadUsuarios] = useState(true)
    const [departamento, setDepartamento] = useState(false)
    const ASOCIACIONES = 'https://www.ancogenecop.com/APIANCO/controllers/asociaciones.php?op='
    useEffect(() => {
        if (reloadUsuarios) {
            const recarga = async () => {
                setReloadUsuarios(false)
                const data = new FormData();
                await fetch(ASOCIACIONES + 'asociaciones', {
                    method: 'POST',
                    header: {
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    },
                    body: data
                }).then((response) => response.json())
                    .then((response) => {
                        if (response != []) {
                            setProducts(response)
                        }
                    setValue1(false)
                    })
                    .catch((error) => {
                        console.log(error);
                    })
            }
            recarga()
        }
    }, [reloadUsuarios])


    const openNew = () => {
        setProduct(emptyProduct);
        setSubmitted(false);
        setProductDialog(true);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setProductDialog(false);
    }


    const saveProduct = async() => {
        console.log(product)
        setSubmitted(true);
         if(product.TID_TERCERO=='') 
         {
         toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el tipo de identificación de la asociación', life: 3000 });
         return;
         }
         
         if(product.NID_TERCERO=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar el número de identificación de la asociación', life: 3000 });
            return;
        }
   
         if(product.NOMBRE=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar el nombre de la asociación', life: 3000 });
            return;
        }
        if(product.DEP_CODIGO=='') 
        {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el departamento de ubicación de la asociación', life: 3000 });
            return;
        }
        if(product.MUN_CODIGO=='') 
        {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar el municipio de ubicación de la asociación', life: 3000 });
            return;
        }        
        if(product.DIRECCION=='') 
        {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar la dirección de la asociación', life: 3000 });
            return;
        }         
         if(product.TELEFONOS=='') 
         {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Debe digitar el teléfono de la asociación', life: 3000 });
            return;
        }
        if(product.CORREO!==''){
            if (!isValidEmail(product.CORREO)) {
            toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: 'El formato del correo no es válido (ej: usuario@dominio.com)', 
                life: 3000 
            });
            return; // ⛔ DETIENE la ejecución. No llama al servidor.
            }
        }
     

        if(product.URL!==''){
            if(!isValidURL(product.URL))
            {
                toast.current.show({ 
                severity: 'error', 
                summary: 'Error', 
                detail: 'El formato de la url no es válido (ej: https://dominio.com)', 
                life: 3000 
            });
            return; // ⛔ DETIENE la ejecución. No llama al servidor.
            }         
        }
         
        const data = new FormData();
        data.append("TID_TERCERO", product.TID_TERCERO)
        data.append("NID_TERCERO", product.NID_TERCERO)
        data.append("NOMBRE", product.NOMBRE)
        data.append("DEP_CODIGO", product.DEP_CODIGO)
        data.append("MUN_CODIGO", product.MUN_CODIGO)
        data.append("DIRECCION", product.DIRECCION)
        data.append("TELEFONOS", product.TELEFONOS)
        data.append("CORREO", product.CORREO)
        data.append("URL", product.URL)
        data.append("adicionar", adicionarRegistro)
        await fetch(ASOCIACIONES + 'ingresarNuevoAsociado', {
            method: 'POST',
            header: {
                'Accept': 'application/json',
                'Content-type': 'application/json'
            },
            body: data
        }).then((response) => response.json())
            .then((response) => {
                if (response == 1) {
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'La Asociación ha Ingresada o Actualizada', life: 3000 });
                    setReloadUsuarios(true)
                    setSubmitted(false);
                    setProductDialog(false);
                    setProduct(emptyProduct);
                } else {
                    toast.current.show({ severity: 'warning', summary: 'Error', detail: 'La Asociación no pudo ser Ingresada o Actualizada', life: 3000 });
                }
            })
            .catch((error) => {
                console.log(error);
            })

    }

    const editProduct = (product) => {
        setProduct({ ...product });
        setAdicionarRegistro(1)
        setProductDialog(true);
    }

        // 1. Función para confirmar y mostrar el toast
const confirmDeleteProduct = (product) => {
    setProduct({ ...product }); // Guardamos el producto seleccionado
    
    confirmDialog({
        message: `¿Está seguro que desea eliminar a ${product.NOMBRE}?`,
        header: 'Confirmar Eliminación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Sí, eliminar',
        rejectLabel: 'No, cancelar',
        acceptClassName: 'p-button-danger',
        accept: () => deleteProduct(product),  // ✅ Si acepta, ejecuta la eliminación
        reject: () => {
            toast.current.show({
                severity: 'info',
                summary: 'Cancelado',
                detail: 'La eliminación fue cancelada',
                life: 3000
            });
        }
    });
}

    // 2. Función que realmente elimina el registro en la base de datos
    const deleteProduct = async (product) => {
        try {
            const data = new FormData();
            data.append("NID_TERCERO", product.NID_TERCERO);

            const response = await fetch(ASOCIACIONES + 'eliminarTercero', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json'
                },
                body: data
            });

            const result = await response.json();

            if (result === 1) {
                toast.current.show({ 
                    severity: 'success', 
                    summary: 'Eliminado', 
                    detail: 'La Asociación ha sido eliminada correctamente', 
                    life: 3000 
                });
                setReloadUsuarios(true); // Recargar la tabla
            } else {
                toast.current.show({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'La Asociación no puede ser eliminada tiene socios en la FEDERACION', 
                    life: 5000 
                });
            }
        } catch (error) {
            console.error('Error al eliminar:', error);
            toast.current.show({ 
                severity: 'error', 
                summary: 'Error de conexión', 
                detail: 'No se pudo conectar con el servidor', 
                life: 3000 
            });
        }
    }


    const exportCSV = () => {
        dt.current.exportCSV();
    }


    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _product = { ...product };
        _product[`${name}`] = val;

        setProduct(_product);
    }


    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Adicionar" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
                </div>
            </React.Fragment>
        )
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <FileUpload mode="basic" accept="image/*" maxFileSize={1000000} label="Importar" chooseLabel="Importar" className="mr-2 inline-block" />
                <Button label="Exportar" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </React.Fragment>
        )
    }
    function calcularEdad(fecha, opcion) {

        if (opcion == 1) {
            product.FECHA_RECEPCION = new Date(fecha).toISOString().slice(0, 10)
        }
    }

const actionBodyTemplate = (rowData) => {
    return (
        <div className="actions">
            <Button 
                icon="pi pi-pencil" 
                className="p-button-rounded p-button-success mr-2" 
                onClick={() => editProduct(rowData)} 
                tooltip="Editar" 
                tooltipOptions={{ position: 'top' }}
            />
            <Button 
                icon="pi pi-trash" 
                className="p-button-rounded p-button-warning mt-2" 
                onClick={() => confirmDeleteProduct(rowData)} 
                tooltip="Eliminar" 
                tooltipOptions={{ position: 'top' }}
            />
        </div>
    );
}
    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Asociaciones</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Enviar" icon="pi pi-check" className="p-button-text" onClick={saveProduct} />
        </>
    );


        const handleplanta = async (dato, opc) => {
        setSubmitted(false)
        if (opc == 1) {
            product.DEP_CODIGO = dato
            setDepartamento(dato)
        }else if(opc == 2){
            product.MUN_CODIGO=dato
        }else if(opc == 6){
            product.TIPO_ASOCIACION=dato
        }else if(opc == 7){
            product.NID_TERCERO=dato
        }else if(opc == 16){
            product.TID_TERCERO=dato
        }
    }
// Función para validar formato de correo electrónico
const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};

// Función para validar formato de URL
const isValidURL = (url) => {
    // Regex que valida URLs completas (http, https, ftp, etc.)
    const regex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i;
    return regex.test(url);
};

    return (
        <>
        {value1 &&
            <div className="formgrid grid">
                 <div className="field col">
                   <h5>Consultado información por favor espere</h5>
                       <div className="col">
                       <ProgressBar mode="indeterminate" style={{ height: '16px', width:'auto' }}></ProgressBar>
                   </div>
               </div>
           </div>
           }

        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <ConfirmDialog />                     
                    <div className="formgrid grid">
                        <div className="field col-12">
                    <Toolbar className="mb-4" left={leftToolbarTemplate} ></Toolbar>

                    <DataTable ref={dt} value={products} selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Mostrando {first} to {last} of {totalRecords} products"
                        globalFilter={globalFilter} emptyMessage="No se encontraron registros." header={header} responsiveLayout="scroll">
                        <Column body={actionBodyTemplate}></Column>
                        <Column field="descripcion" header="TID_TERCERO" sortable ></Column>
                        <Column field="NID_TERCERO" header="NID_TERCERO" sortable ></Column>
                        <Column field="NOMBRE" header="NOMBRE" sortable ></Column>
                        <Column field="DEPARTAMENTO" header="DEPARTAMENTO" sortable ></Column>
                        <Column field="MUNICIPIO" header="MUN_CODIGO" sortable ></Column>
                        <Column field="DIRECCION" header="DIRECCION" sortable ></Column>
                        <Column field="TELEFONOS" header="TELEFONOS" sortable ></Column>
                        <Column field="CORREO" header="CORREO" sortable ></Column>
                        <Column field="URL" header="URL" sortable ></Column>
                    </DataTable>
                    </div>
                    {/* <div className="field col-3"><Lateral/>

                    </div> */}
                    </div>
                    <Dialog visible={productDialog} style={{ width: '650px' }} header="Detalle de la Asociación" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                    <div className="formgrid grid">
                             <div className="field col-6">
                                <label htmlFor="name">Tipo Documento Asociación</label>
                                <SeleccionTipoDocumentoOtros handleplanta={handleplanta} NOMBRE={product.descripcion} />
                                {submitted && !product.TID_TERCERO && <small className="p-invalid" required
                                style={{
                                    color: 'red',
                                }}>El tipo de documento es requerido.</small>}
                            </div>
                            <div className="field col">
                                <label htmlFor="name">Nid. Asociación </label>                                
                                    <InputText 
                                        id="name" 
                                        value={product.NID_TERCERO} 
                                        onChange={(e) => onInputChange(e, 'NID_TERCERO')} 
                                        required={adicionarRegistro === 0}
                                        readOnly={adicionarRegistro !== 0}   
                                        className={classNames({ 'p-invalid': submitted && adicionarRegistro === 0 && !product.NID_TERCERO })} 
                                    />
                                    {submitted && adicionarRegistro === 0 && !product.NID_TERCERO && (
                                        <small className="p-invalid" style={{ color: 'red' }}>
                                            Número de identificación es requerido
                                        </small>
                                    )}
                            </div>
                      </div>
                      <hr/>
                            <div className="field col">
                                    <label htmlFor="name">Nombre de la Asociación</label>
                                    <InputText id="name" value={product.NOMBRE} onChange={(e) => onInputChange(e, 'NOMBRE')} required />
                                    {submitted && !product.NOMBRE && <small className="p-invalid" required
                                style={{
                                    color: 'red',
                                }}>El nombre es requerido.</small>}
                            </div>
                            <hr/>
                    <div className="formgrid grid">
                    <div className="field col">
                            <label htmlFor="name">Departamento ubicación</label>
                            <SeleccionDepartamento  handleplanta={handleplanta} DEPARTAMENTO={product.DEPARTAMENTO}
                            required
                            />
                            {submitted && !product.DEP_CODIGO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>El departamento es requerido.</small>}
                        </div>
                        <div className="field col">
                            <label htmlFor="name">Municipio ubicación</label>
                            <SeleccionMunicipios  handleplanta={handleplanta} MUNICIPIO={product.MUNICIPIO} CODIGO={departamento}
                            required
                            />
                            {submitted && !product.MUN_CODIGO && <small className="p-invalid"
                            style={{
                              color: 'red',
                            }}>Es municipio es requerido.</small>}
                        </div>
                    </div>
                    <hr/>
                    <div className="formgrid grid">
                        <div className="field col">
                                <label htmlFor="name">Dirección</label>
                                <InputText id="name" value={product.DIRECCION} onChange={(e) => onInputChange(e, 'DIRECCION')} required />
                                {submitted && !product.DIRECCION && <small className="p-invalid" required
                            style={{
                                color: 'red',
                            }}>La dirección es requerida.</small>}
                        </div>
                        <div className="field col">
                                <label htmlFor="name">Teléfono(s)</label>
                                <InputText id="name" value={product.TELEFONOS} onChange={(e) => onInputChange(e, 'TELEFONOS')} required />
                                {submitted && !product.TELEFONOS && <small className="p-invalid" required
                            style={{
                                color: 'red',
                            }}>El teléfono es requerida.</small>}
                        </div>
                    </div>
                    <hr/>
                    <div className="formgrid grid">
                        <div className="field col">
                                <label htmlFor="CORREO">Correo</label>
                                <InputText 
                                    id="CORREO" 
                                    type="email"
                                    value={product.CORREO || ''} 
                                    onChange={(e) => onInputChange(e, 'CORREO')} 
                                    required 
                                    className={classNames({ 
                                        'p-invalid': (submitted && !product.CORREO) || 
                                                    (product.CORREO && !isValidEmail(product.CORREO)) 
                                    })}
                                />
                            </div>
                        <div className="field col">
                            <label htmlFor="URL">Url</label>
                            <InputText 
                                id="URL" 
                                value={product.URL || ''} 
                                onChange={(e) => onInputChange(e, 'URL')} 
                                className={classNames({ 
                                    'p-invalid': (submitted && !product.URL) || 
                                                (product.URL && !isValidURL(product.URL)) 
                                })}
                            />
                        </div>
                    </div>
                    <hr/>
                   
                    </Dialog>


                </div>
            </div>
        </div>
        </>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Terceros, comparisonFn);
